var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIdle = function SvgIdle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 20.3333H18.4V19.135C18.4 16.4908 17.0312 14.0342 14.828 12.7233C14.464 12.5067 14.4248 12.1458 14.4248 12C14.4248 11.8542 14.464 11.4933 14.828 11.2767C17.0312 9.96583 18.4 7.50833 18.4 4.865V3.66667H19.2C19.6424 3.66667 20 3.29417 20 2.83333C20 2.3725 19.6424 2 19.2 2H4.8C4.3576 2 4 2.3725 4 2.83333C4 3.29417 4.3576 3.66667 4.8 3.66667H5.6V4.865C5.6 7.50917 6.9688 9.96583 9.172 11.2767C9.536 11.4933 9.5752 11.8542 9.5752 12C9.5752 12.1458 9.536 12.5067 9.172 12.7233C6.9688 14.0342 5.6 16.4917 5.6 19.1358V20.3333H4.8C4.3576 20.3333 4 20.7058 4 21.1667C4 21.6275 4.3576 22 4.8 22H19.2C19.6424 22 20 21.6275 20 21.1667C20 20.7058 19.6424 20.3333 19.2 20.3333Z",
    fill: "#696593"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIdle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Idle.280a7a777e9d654942098a419db65c65.svg";